<div *ngIf="showBeneficiary && params?.payment=='form'" class="beneficiary-details d-sm-none">
    <div class="flex-div align-items-center">
      <ng-template [ngTemplateOutlet]="profilePic"></ng-template>
      <div class="details">
        <span>Contribute to:</span>
        <div class="bene-name">{{variablesService?.beneficiary?.full_name}}</div>
        <span class="heading">{{'Stories.donations.beneficiary' | translatePipe | async}}<i class="material-icons check-circle">check_circle</i></span>
      </div>
      <div>
        <app-ketto-assured></app-ketto-assured>
      </div>
    </div>
  </div>
  <header [ngClass]="{'white-header': params?.payment=='options' && isMobile}" class="stories-header">

    <div class="stories-img-wrapper" *ngIf="params.ct">
        <img class="left-img" [src]="variablesService?.fundraiser?.beneficiary?.avtar?.cdn_path ? variablesService?.fundraiser?.beneficiary?.avtar?.cdn_path: utilService.defaultImg" alt="">
    </div>
    <div class="title-stories" *ngIf="params.ct">
        <div class="main">
            {{'Support ' + variablesService.fundraiser?.campaigner?.full_name}}
        </div>
        <a class="sub-title" *ngIf="params.ct" [routerLink]="['/stories/', params.ct]" [queryParams]="{frm: 'payment'}">
          View Story
        </a>
    </div>
    <div *ngIf="params?.type!=='lead'" class='you-are-donating'>
      <div [style.display]="params.payment=='options'?'none':'block'" class="currency-dropdown">
        <app-currency-dropdown *ngIf="supportedCurrencies" [currencies]="supportedCurrencies"
                                [selectedCurrency]="currency" (userSelectionCurrency)="setCurrency($event)">
        </app-currency-dropdown>
      </div>
    </div>
  </header>
  
  <ng-template #profilePic>
    <div *ngIf="fundraiser?.media_beneficiary" class="profile-img">
      <img loading="lazy" alt="donor_img" [attr.data-src]="fundraiser?.media_beneficiary?.cdn_path" [alt]="'Profile Pic - '+variablesService?.beneficiary?.full_name" />
    </div>
    <i *ngIf="!fundraiser?.media_beneficiary" class="icon-user1"></i>
  </ng-template>
  